import React from 'react'
import { pp_IMG_URL } from '../utils/Constants'

const Cast = ({image_url, original_name, character}) => {   
  if(!image_url) return null;
  
  return (
    <div className=' h-min backdrop-blur-sm p-4'>
    <div className='text-center'>
        <img className='rounded-lg' src={pp_IMG_URL + image_url} />
        <p className='text-white text-sm font-bold'>{original_name}</p>       
        <p className='text-xs text-white underline-offset-0 decoration-slate-400'>(Charater)</p>
        <p className='text-white text-xs'> {character}</p>
    </div>
    </div>
  )
}

export default Cast